import Loader from 'bzx-common/src/ui-framework/components/Loader'
import React from 'react'
import OokiversityPost from './OokiversityPost'
import { BlogStore } from 'bzx-common/src/stores'
import { observer } from 'mobx-react'

export const OokiversityPosts = ({ blogStore }: { blogStore: BlogStore }) => {
  const showLoader = !blogStore.posts.loaded && !blogStore.posts.error
  return (
    <div className="panel--simple md-padded-2 margin-top-1">
      <h3 className="title-section flex-row-center">Ookiversity articles</h3>
      <div className="padded-bottom-1">
        <div className="learn__blog-posts">
          {showLoader && <Loader quantityDots={3} sizeDots={'middle'} />}
          {blogStore.posts.value.length > 0 &&
            blogStore.ookiversityPosts.map((post) => (
              <OokiversityPost post={post} key={post.url} />
            ))}
          {blogStore.posts.error !== null && (
            <p className="txt-warning">{blogStore.posts.error.message}</p>
          )}
        </div>
      </div>
    </div>
  )
}

export default observer(OokiversityPosts)
